<template>
  <div class="">
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Proceed to Followup Manually">
        <v-card-actions>
          <router-link :to="{ name: 'followup' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute top right>
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
              class="mr-n2 mt-10" style="opacity:.6;">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form name="getReport" autocomplete="off" @submit.prevent="onSubmit" novalidate>
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="4">
                <span class="body-2 font-weight-medium">Status<span
                    class="error--text ml-1">*</span></span>
                <v-autocomplete v-model="enquiryStageID" :items="enquiryStageData" item-text="name"
                  item-value="id" label="--Select--" class="my-0 py-1" single-line required>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="4">
                <span class="body-2 font-weight-medium">From<span
                    class="error--text ml-1">*</span></span>
                <custom-date-picker prepend-icon="mdi-calendar" v-model="fromDate" required />
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="4">
                <span class="body-2 font-weight-medium">To<span
                    class="error--text ml-1">*</span></span>
                <custom-date-picker prepend-icon="mdi-calendar" :minToDate="fromDate"
                  v-model="toDate" required />
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="4">
                <span class="body-2 font-weight-medium">Filter Action</span>
                <div class="inside">
                  <v-btn color="success" elevation="1" type="submit">
                    <v-icon left> mdi-magnify </v-icon>
                    Show Result
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1"
            :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              <!-- Total Records : {{ total }} -->
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
              hide-details single-line style="max-width:350px;" />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }" :items-per-page="10" :headers="headers" :items="reportData" :search="search">
            <template v-slot:item.enquiryDate="{ item }">
              <span>{{ item.enquiryDate ? item.enquiryDate : '' }}</span>
            </template>

            <template v-slot:item.count="{ item }">
              <span>{{ item.count ? item.count : '' }}</span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn class="px-2 ml-1 ma-1" @click="setReportData(item.enquiryDate)" min-width="0"
                v-show="reportData" small>
                <v-icon small color="black"> mdi-eye </v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
// import followupDashboard from '@/components/Admission/Followup/followupDashboard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import _ from 'lodash'
import moment from 'moment'
import stores from '@/stores'

export default {
  name: 'manualProcess',
  components: {
    // followupDashboard,
    VCardComponent,
    MaterialCard,
    CustomDatePicker
  },
  data () {
    return {
      isLoading: false,
      search: '',
      loadingComponent: null,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      academicYearsFilter: [],
      enquirySources: [],
      academicYearID: '',
      academicYearFilterID: '',
      enquirySource: 0,
      reportData: [],
      enquiryStageData: [],
      enquiryStageID: '',
      followupStatus: {},
      isOpen: false,
      total: 0,
      followupType: 'academic',
      followupTypeData: constants.FOLLOWUPTYPE,
      statusData: constants.FOLLOWUPSTATUS,
      headers: [
        { text: 'Date', value: 'enquiryDate', sortable: true },
        { text: 'Count', value: 'count', sortable: true },
        { text: 'Action', value: 'actions', align: 'center' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear',
      updateFollowupAcademicYearID: 'updateFollowupAcademicYearID',
      updateFollowupEnquiryDate: 'updateFollowupEnquiryDate'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
      this.reportData = []
      await this.getReport()
      if (!_.isEmpty(this.followupStatus) && !_.isEmpty(this.fromDate) && !_.isEmpty(this.toDate) && !_.isEmpty(this.followupType)) {
        await this.onSubmit()
      }
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (stores.manualProcess !== undefined) {
        // To patch the previous selection
        this.enquiryStageID = stores.manualProcess.enquiryStageID
        this.fromDate = stores.manualProcess.fromDate
        this.toDate = stores.manualProcess.toDate
      }
      await this.getAcademicYears()
      await this.getEnquirySources()
      await this.getEnquiryStages()
      const currentAcademicYear = Utils.getCurrentAcademicYear()

      let academicYear = _.find(this.academicYears, (y) => y.academicYear.trim() === currentAcademicYear.trim())

      this.academicYearID = this.academicYearFilterID = academicYear ? academicYear.id : ''
      this.isLoading = false
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }
  },
  beforeDestroy () {
    console.log('manualProcess Vue destroyed')
    // Storing the current selection
    stores.manualProcess = {
      enquiryStageID: this.enquiryStageID,
      fromDate: this.fromDate,
      toDate: this.toDate
    }
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        console.log('Change: ' + this.franchisee.id)
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        await this.getEnquiryStages()
        this.inProgress = false
      }
    },
    getAcademicYears: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        this.flag = false
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
        await this.getReport()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getEnquirySources: async function () {
      const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
      this.enquirySources = questions.filter((obj) => obj.type === 'SOURCE_OF_CONTACT')
    },
    getEnquiryStages: async function () {
      const { data } = await http.get(`${constants.API_URL}/api/getEnquiryStages`)
      this.enquiryStageData = _.filter(data, (y) => {
        y.name = y.statusName + '-' + y.name
        return y
      })
      this.enquiryStageData.unshift({
        id: '',
        name: 'All',
        statusName: 'Enquiry'
      })
    },
    getReport: async function () {
      this.reportData = []
      try {
        this.isLoading = true
        this.lock = true
        if (!_.isEmpty(this.fromDate) && !_.isEmpty(this.toDate)) {
          const formData = {
            franchiseeID: this.franchiseeID,
            fromDate: this.fromDate,
            toDate: this.toDate,
            academicYearID: this.academicYearID,
            enquiryStageID: this.enquiryStageID
          }
          const response = await http.post(`${constants.API_URL}/api/getFollowupStatusReports`, formData)
          if (response) {
            console.log('Data fetched successfully.')
            this.reportData = response.data
            console.log(this.reportData)
            this.total = this.reportData.reduce((acc, item) => acc + item.count, 0)
          }
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    onSubmit: async function () {
      this.reportData = []
      try {
        this.isLoading = true
        this.lock = true
        if (!_.isEmpty(this.fromDate) && !_.isEmpty(this.toDate)) {
          if (this.fromDate <= this.toDate) {
            const formData = {
              franchiseeID: this.franchisee.id || '',
              fromDate: this.fromDate,
              toDate: this.toDate,
              academicYearID: this.academicYearID,
              enquiryStageID: this.enquiryStageID
            }
            const response = await http.post(`${constants.API_URL}/api/getFollowupStatusReports`, formData)
            if (response) {
              this.reportData = response.data
              console.log('On Submit data')
              console.log(this.reportData)
              this.total = this.reportData.reduce((acc, item) => acc + item.count, 0)
            }
            this.isLoading = false
          } else {
            this.isLoading = false

            const errorMessage = 'From date should be less than To date'
            return this.$dialog.error({
              text: errorMessage,
              title: 'Error'
            })
          }
        } else {
          this.isLoading = false

          const errorMessage = 'Please select Mandatory fields'
          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        }
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    setReportData: async function (enquiryDateObj) {
      let academicYrID = this.academicYearID ? this.academicYearID : ''
      let enquiryDate = enquiryDateObj

      let enquiryStageID = this.enquiryStageID
      this.$store.commit('updateFollowupAcademicYearID', academicYrID)
      this.$store.commit('updateFollowupEnquiryDate', enquiryDate)
      this.$store.commit('updateEnquiryStageID', enquiryStageID)

      this.$router.push({
        name: 'followup',
        query: { academicYrID: academicYrID, enquiryDate: enquiryDate, enquiryStageID: enquiryStageID }
      })
    }
  }
}
</script>
